import {Component, Input} from '@angular/core';
import {Company} from "../../../../interfaces/company.interface";

@Component({
  selector: 'app-industry-landscape',
  templateUrl: './industry-landscape.component.html',
  styleUrls: ['./industry-landscape.component.scss']
})
export class IndustryLandscapeComponent {

  @Input() reportSearch: any;
  @Input() company: Company;
  @Input() edit: boolean | undefined;

}
